import Bugsnag from '@bugsnag/browser';
import { Buyer, TransactionRequest } from '@src/core/buyerApiClient';
import {
  ExternalAuthenticationProviderType,
  type PaymentMethodExternalAuthentication,
  type PaymentOption,
} from '@src/domains/payments';
import { AppDispatch } from '@src/core/store';
import type { Transactable } from '@src/domains/transactables';
import { ExternalAuthenticationProviderFactory } from '@src/features/payments/external-auth/factory';
import type { ExternalAuthResult } from '@src/features/payments/external-auth/types';

type HandleExternalAuthenticationParams = {
  widgetUrl: string;
  paymentOption: PaymentOption;
  transactable: Transactable;
  data: TransactionRequest;
  paymentMethodExternalAuthentication: PaymentMethodExternalAuthentication;
  maxAttempts: number;
  dispatch: AppDispatch;
  buyer?: Buyer;
};

const handleExternalAuthentication = async (
  params: HandleExternalAuthenticationParams,
): Promise<ExternalAuthResult> => {
  const { paymentMethodExternalAuthentication } = params;

  switch (paymentMethodExternalAuthentication.type) {
    case ExternalAuthenticationProviderType.Bpmpi:
    case ExternalAuthenticationProviderType.Pgmpi:
    case ExternalAuthenticationProviderType.Malga3ds2:
      return await ExternalAuthenticationProviderFactory.handleAuthentication(params);
    default:
      Bugsnag.notify({
        name: 'ExternalAuth',
        message: `Unsupported external authentication provider: ${paymentMethodExternalAuthentication.type}`,
      });
      return {
        proceed: false,
        error: 'UNSUPPORTED_EXTERNAL_AUTHENTICATION_PROVIDER',
        externalAuthentication: undefined,
      };
  }
};

export default handleExternalAuthentication;
